import softDelete from '../../../abstract/actions/soft-delete';
import edit from './edit';
import execute from './execute';

export default {
  execute,
  edit,
  softDelete,
};
